module.exports = __webpack_public_path__ + "static/media/AF.36bea42f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AF.svg
// module id = 185
// module chunks = 0